import { Crown, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { fetchTopRunners } from "../utils/rewards";

const SEEN_KEY = "dolo-weekly-prize-seen";

export function WeeklyPrize() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [leader, setLeader] = useState(null);

  useEffect(() => {
    if (pathname !== "/rewards") return undefined;
    if (sessionStorage.getItem(SEEN_KEY)) return undefined;
    let cancelled = false;
    let timer;
    // never stack on top of the daily ration popup
    const tryOpen = (attempt = 0) => {
      if (cancelled) return;
      if (document.querySelector('[data-testid="daily-ration-popup"]') && attempt < 12) {
        timer = window.setTimeout(() => tryOpen(attempt + 1), 4000);
        return;
      }
      setOpen(true);
      sessionStorage.setItem(SEEN_KEY, "1");
    };
    timer = window.setTimeout(() => tryOpen(), 5000);
    fetchTopRunners()
      .then((rows) => {
        if (!cancelled && rows[0]) setLeader(rows[0]);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [pathname]);

  if (!open) return null;

  return (
    <div className="weekly-prize-overlay" data-testid="weekly-prize-popup" role="dialog" aria-label="Weekly leaderboard prize">
      <div className="weekly-prize-card">
        <button type="button" className="weekly-prize-close" onClick={() => setOpen(false)} data-testid="weekly-prize-close" aria-label="Close weekly prize">
          <X size={14} />
        </button>
        <span className="weekly-prize-eyebrow">LEADERBOARD PRIZES // WEEKLY</span>
        <h3>
          <Crown size={22} /> RUNNER OF THE WEEK
        </h3>
        <p>
          Every week the top runner on the DOLO REWARDS board gets the highlighted golden badge locked beside their tag —
          pinned at #1 for the whole mesh to chase. Stack points. Take the crown.
        </p>
        <p className="weekly-prize-leader" data-testid="weekly-prize-leader">
          {leader ? `CURRENT LEADER — ${leader.tag} · ${leader.points} PTS` : "NO CROWNED RUNNER YET — THE BOARD IS OPEN."}
        </p>
        <button type="button" className="weekly-prize-cta" onClick={() => setOpen(false)} data-testid="weekly-prize-cta">
          I'M COMING FOR IT
        </button>
      </div>
    </div>
  );
}
